import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
//import { Observable } from 'rxjs/Observable';

@Injectable()
export class ChooseGuard implements CanActivate {
    constructor(public http: HttpClient) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        //am i logged in at all
        return this.http.get('/Users/AuthedUser').toPromise().then((res: any) => {
            if ((res?.Role === "Manager" || res?.Role === "AM" )) {
                //console.log("Authed Choose.Guard")
                return true;
            }
            else {
                console.log("Not Authed Choose.Guard")
               // localStorage.removeItem("User");
               /// localStorage.removeItem("Role");
//localStorage.removeItem('Shop');
               // localStorage.removeItem('Brand');
                //this.router.navigate(['/']);//still need to be authed here
                window.location.href = "/";
                return false;
            }
        });
    }
}
